import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { ErrorLike } from '@apollo/client';
import '../EquipmentProfile.scss';
import { Loading, Error } from '../../../_common';
import {
    GetAssetInfoByLoadId_getAssetInfoByLoadId as AssetInfoType,
} from '../../../../types/schemaTypes';

interface EquipmentDetailsProps {
    assetInfo: AssetInfoType[],
    assetInfoLoading: boolean,
    assetInfoError: ErrorLike | undefined,
}

const EquipmentDetails = ({
    assetInfo,
    assetInfoError,
    assetInfoLoading,
}: EquipmentDetailsProps): React.ReactElement => {
    return (
        <Col>
            <Row className="LoadDetail-Title">Equipment Details</Row>
            {assetInfoLoading ? (
                <div className="EquipmentProfile-Loading ">
                    <Loading />
                </div>
            ) : assetInfoError ? (
                <div className="EquipmentProfile-Error">
                    <Error error={assetInfoError} />
                </div>
            ) : assetInfo.length === 0 ? (
                <div className="NoResult-Second-Title-Primary EquipmentProfile-NoResult">No Equipment Details Found</div>
            ) : (
                <Table striped bordered className="tabletest EquipmentsDetails">
                    <thead>
                        <tr>
                            <th>Equipment Type</th>
                            <th>ID</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assetInfo.map((info, index) => (
                            <tr key={index}>
                                <td>{info.assetType}</td>
                                <td>{info.assetDescrip}</td>
                                <td>{info.quantity}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Col>
    );
};

export default EquipmentDetails;
